type valueType = number | string;
interface SelectOpts {
	label: string;
	value: valueType;
}

export function MapToSelectOpts(map: Map<valueType, string>): SelectOpts[] {
	return Array.from(map, ([k, v]) => ({value: k, label: v}));
}
